import { useTranslation } from 'react-i18next';

import { Container, Header } from '~/components';

import { DocumentsTable } from './DocumentsTable';

export const Documents = () => {
  const { t } = useTranslation(['settings']);

  return (
    <>
      <Header.Root>
        <Header.Content title={t('settings:documents.title')} />
      </Header.Root>

      <Container>
        <DocumentsTable />
      </Container>
    </>
  );
};
